/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  IconButton,
  Typography,
  Button,
  Tabs,
  Tab,
  TextField,
  MenuItem,
  Menu,
  Divider,
  DialogActions,
} from "@mui/material";
import WorkHistoryOutlinedIcon from "@mui/icons-material/WorkHistoryOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PersonAddAlt1OutlinedIcon from "@mui/icons-material/PersonAddAlt1Outlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import CloseIcon from "@mui/icons-material/Close";
import PersonIcon from "@mui/icons-material/Person";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import LinkIcon from "@mui/icons-material/Link";
import ScreenShareOutlinedIcon from "@mui/icons-material/ScreenShareOutlined";
import LibraryAddOutlinedIcon from "@mui/icons-material/LibraryAddOutlined";
import dayjs from "dayjs";
import CustomSnackbar from "../../components/Composables/CustomSnackBarMenu";
import API from "../../Utils/Interceptor/ApiMiddleware";
import CandidateInternalProfile from "../../components/Composables/CandidateInternalProfile";
import QuestionsPopUp from "../../components/Composables/QuestionsPopUp";
import LoadingSpinner from "../../components/Composables/CircularProgressBar";

export default function ShortlistedDialog({
  open,
  close,
  candidateData,
  sourceType,
  tabValue,
  setTabValue,
  candidateId,
  jobId,
  fetchCandidateData,
  questionsData,
  shortlisted,
  title,
  dateModified,
  currentStatus,
  fetchJobShortlistedDetails,
  fetchJobApplicantsDetails,
}) {
  const selectedTab = tabValue;
  const data = candidateData || {};
  const resumeRef = useRef(null);
  const [status, setStatus] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const openStatusMenu = Boolean(anchorEl);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const [openWriteCommentDialog, setOpenWriteCommentDialog] = useState(false);
  const [openstatusCommentDialog, setOpenStatusCommentDialog] = useState(false);
  const [usedStatuses, setUsedStatuses] = useState([]);
  const [comment, setComment] = useState("");
  const [openQuestionsDialog, setOpenQuestionsDialog] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "error",
  });
  useEffect(() => {
    console.log(selectedStatus);
  }, [selectedStatus]);
  const getIcon = (comment) => {
    if (comment?.includes("applied")) {
      return (
        <Box
          className="icon-container"
          sx={{
            border: " 1px solid rgba(33, 150, 243, 0.20)",
            borderRadius: "10px",
            height: "60px",
            minWidth: "60px",

            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            transition: "background-color 0.5s",
          }}
        >
          <PersonOutlineOutlinedIcon
            className="icon"
            style={{ color: "#979797" }}
          />
        </Box>
      );
    } else if (comment?.includes("created")) {
      return (
        <Box
          className="icon-container"
          sx={{
            border: " 1px solid rgba(255, 169, 60, 0.20)",
            borderRadius: "10px",
            height: "60px",
            minWidth: "60px",

            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            transition: "background-color 0.5s",
          }}
        >
          <PersonAddAlt1OutlinedIcon
            className="icon"
            style={{ color: "#979797" }}
          />
        </Box>
      );
    } else {
      return (
        <Box
          className="icon-container"
          sx={{
            border: " 1px solid rgba(76, 175, 80, 0.20)",
            borderRadius: "10px",
            height: "60px",
            minWidth: "60px",

            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            transition: "background-color 0.5s",
          }}
        >
          <WorkHistoryOutlinedIcon
            className="icon"
            style={{ color: "#979797" }}
          />
        </Box>
      );
    }
  };

  const handleApplyNow = (quesAnsArray = []) => {
    API.post(`/job/apply-job`, {
      candidate_ids: [candidateId],
      job_id: jobId,
      isShortlisted: shortlisted ? 1 : 0,
      quesAnsArray,
    })
      .then((res) => {
        if (res?.data?.success) {
          setSnackbar({
            open: true,
            message: res?.data?.data?.message,
            severity: "success",
          });
          setTimeout(() => {
            close();
            fetchJobApplicantsDetails();
            fetchJobShortlistedDetails();
          }, 1000);
        }
      })
      .catch((err) => {
        setSnackbar({
          open: true,
          message: err?.response?.data?.message,
          severity: "error",
        });
      });
  };

  const handleApply = () => {
    questionsData.length > 0 ? setOpenQuestionsDialog(true) : handleApplyNow();
  };

  const getColor = (comment) => {
    if (comment?.includes("applied")) {
      return "#2196F3";
    } else if (comment?.includes("created")) {
      return "#FFA93C";
    } else {
      return "#4CAF50 ";
    }
  };

  const handleShareProfile = async () => {
    // const x = process.env.REACT_FRONTEND_URL;
    try {
      await navigator.clipboard.writeText(
        `${process.env.REACT_APP_FRONTEND_URL}/candidates-description/${candidateId}`
      );
      setSnackbar({
        open: true,
        message: "Link copied to clipboard",
        severity: "success",
      });
    } catch (err) {
      console.error(err);
      setSnackbar({
        open: true,
        message: "Failed to copy link",
        severity: "error",
      });
    }
  };
  useEffect(() => {
    if (currentStatus) {
      setUsedStatuses([currentStatus]);
    }
  }, [currentStatus]);
  const handleAddCommentStatus = async () => {
    const obj = {
      id: candidateId,
      date_modified: dateModified,
      currentStatus,
    };
    setLoading(true);
    try {
      const response = await API.post(`/job/change-candidate-job-status`, {
        candidate_ids: [obj],
        comment,
        job_id: jobId,
        status: selectedStatus,
      });

      if (response?.data?.success) {
        setSnackbar({
          open: true,
          message: "Candidate status changed successfully",
          severity: "success",
        });

        setUsedStatuses([selectedStatus]);
        setOpenStatusCommentDialog(false);
        setTabValue("Activities");
        fetchJobShortlistedDetails();
        setComment("");
        setSelectedStatus("");
        fetchCandidateData();
      }
    } catch (error) {
      console.error(error);
      setSnackbar({
        open: true,
        message: "Failed to change candidate status",
        severity: "error",
      });
      setOpenStatusCommentDialog(false);
      setComment("");
      setSelectedStatus("");
    } finally {
      setLoading(false);
    }
  };

  const handleAddComment = async () => {
    setLoading(true);
    try {
      const response = await API.post(`/job/add-comment`, {
        comment,
        candidateId,
        jobId,
      });
      if (response?.data?.success) {
        setSnackbar({
          open: true,
          message: "Comment added successfully",
          severity: "success",
        });
        setOpenWriteCommentDialog(false);
        setComment("");
        fetchCandidateData();
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: "Failed to add comment",
        severity: "error",
      });
      setOpenWriteCommentDialog(false);
      setComment("");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (!open) return;

    API.get("/candidate/job-status")
      .then((response) => {
        setStatus(response.data.data);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [open && sourceType === "Applicants"]);

  const renderSection = (title, sectionData) => {
    if (!sectionData || typeof sectionData !== "object") return null;

    return (
      <Box sx={{ marginBottom: "24px" }}>
        <Typography
          variant="h6"
          sx={{ fontSize: "14px", fontWeight: 600, marginBottom: "8px" }}
        >
          {title}
        </Typography>

        {Object.entries(sectionData).map(([key, value], index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              gap: "20px",
              marginBottom: "8px",
              alignItems: "flex-start",
              flexWrap: "wrap",
            }}
          >
            <Typography
              sx={{
                fontWeight: 400,
                minWidth: "200px",
                color: "#666666",
                fontSize: "14px",
              }}
            >
              {key}
            </Typography>

            {Array.isArray(value) ? (
              value.length > 0 ? (
                <Box sx={{ flex: 1 }}>
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "8px",
                    }}
                  >
                    {value.map((item, i) => (
                      <Box
                        key={i}
                        sx={{
                          fontSize: "12px",
                          padding: "4px 8px",
                          backgroundColor: "#E3F2FD",
                          borderRadius: "16px",
                          color: "#006CB7",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {item}
                      </Box>
                    ))}
                  </Box>
                </Box>
              ) : (
                <Typography sx={{ color: "#212121" }}>NA</Typography>
              )
            ) : (
              <>
                {key.includes("Linkedin") || key.includes("Portfolio Link") ? (
                  value ? (
                    <a
                      href={value}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: "#006CB7",
                        textDecoration: "underline",
                        wordBreak: "break-all",
                        fontSize: "14px",
                      }}
                    >
                      {value}
                    </a>
                  ) : (
                    <Typography sx={{ color: "#212121", fontSize: "14px" }}>
                      NA
                    </Typography>
                  )
                ) : (
                  <Typography sx={{ color: "#212121", fontSize: "14px" }}>
                    {(key === "Date of Birth" ||
                      key === "Last Working Day" ||
                      key === "Expected Joining Date") &&
                    value
                      ? (() => {
                          const date = new Date(value);
                          const day = String(date.getDate()).padStart(2, "0");
                          const month = String(date.getMonth() + 1).padStart(
                            2,
                            "0"
                          );
                          const year = date.getFullYear();
                          return `${day}-${month}-${year}`;
                        })()
                      : key === "Expected Salary" || key === "Current Salary"
                      ? value
                        ? `$${value}`
                        : "NA"
                      : !value || value === "null, null"
                      ? "NA"
                      : value}
                  </Typography>
                )}
              </>
            )}
          </Box>
        ))}
      </Box>
    );
  };
  const scrollToResume = () => {
    resumeRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <Dialog
      open={open}
      onClose={close}
      maxWidth="lg"
      PaperProps={{
        sx: { borderRadius: "18px", width: "900px", height: "600px" },
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{
          padding: "16px 24px",
          borderBottom: "1px solid rgba(0, 0, 0, 0.10)",
        }}
      >
        <DialogTitle sx={{ flex: 1, padding: "0px" }}>
          <Typography variant="h5" fontWeight={"bold"}>
            Profile
          </Typography>
        </DialogTitle>
        <IconButton onClick={close} sx={{ color: "#101828 !important" }}>
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogContent>
        <Box sx={{ display: "flex", gap: "16px", alignItems: "center" }}>
          <Box
            sx={{
              width: "110px",
              height: "110px",
              backgroundColor: "#E3F2FD",
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <PersonIcon sx={{ fontSize: "110px", color: "#979797" }} />
          </Box>
          <Box sx={{ flex: 1 }}>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Box>
                <Typography fontSize={"20px"} fontWeight={600}>
                  {data?.["Basic Details"]?.["Name"] || "Person Name"}
                </Typography>
                <Typography sx={{ fontSize: "14px", color: "#00000099" }}>
                  Created by {data?.["More Details"]?.["Created By"] || "N/A"}
                </Typography>
                <Typography sx={{ fontSize: "14px", color: "#00000099" }}>
                  Last login :{" "}
                  <span style={{ color: "black" }}>
                    {(() => {
                      const loginDate =
                        data?.["More Details"]?.["Last Login"] || "NA";
                      if (!loginDate) return "More than 90 days ago";

                      const daysAgo = dayjs().diff(dayjs(loginDate), "days");

                      if (daysAgo <= 7) return `Last 7 days`;
                      if (daysAgo <= 30) return `Last month`;
                      if (daysAgo <= 90) return `Last 90 days`;
                      return `More than 90 days ago`;
                    })()}
                  </span>
                </Typography>
                <Typography sx={{ fontSize: "14px", color: "#00000099" }}>
                  Views in last 90 days :{" "}
                  <span style={{ color: "black" }}>
                    {data?.["More Details"]?.["Profile Visit Count"] || "0"}
                  </span>
                </Typography>
              </Box>
              <Box>
                {sourceType === "Shortlisted" && (
                  <Button variant="contained" onClick={handleApply}>
                    APPLY
                  </Button>
                )}
                {sourceType === "Applicants" && (
                  <Button
                    variant="contained"
                    onClick={(e) => setAnchorEl(e.currentTarget)}
                    sx={{
                      padding: 0,
                      overflow: "hidden",
                      minWidth: "auto",
                      borderRadius: 1.5,
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: "#2E84C0",
                        color: "#fff",
                        padding: "6px 12px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      Status
                    </Box>

                    <Box
                      sx={{
                        backgroundColor: "#006CB7",
                        color: "#fff",
                        padding: "6px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <ExpandMoreIcon />
                    </Box>
                  </Button>
                )}
                <Menu
                  anchorEl={anchorEl}
                  open={openStatusMenu}
                  onClose={() => setAnchorEl(null)}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                  }}
                >
                  {status.map((item, index) => (
                    <MenuItem
                      key={index}
                      disabled={usedStatuses.includes(item.status)}
                      onClick={() => {
                        setSelectedStatus(item.status);
                        setAnchorEl(null);
                        setOpenStatusCommentDialog(true);
                      }}
                    >
                      {item.status}
                    </MenuItem>
                  ))}
                </Menu>
                <Dialog
                  open={openstatusCommentDialog}
                  onClose={() => {
                    setOpenStatusCommentDialog(false);
                    setComment("");
                    setSelectedStatus("");
                  }}
                  maxWidth="xs"
                  fullWidth
                  PaperProps={{ style: { borderRadius: "16px" } }}
                >
                  <DialogTitle>
                    <Typography variant="h6" fontWeight={"bold"}>
                      Change Status
                    </Typography>
                  </DialogTitle>
                  <Divider />
                  <DialogContent>
                    <Box sx={{ position: "relative" }}>
                      {loading && (
                        <Box
                          sx={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            zIndex: 10,
                            width: "100%",
                            height: "100%",
                            backgroundColor: "rgba(255, 255, 255, 0.6)",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            borderRadius: "16px",
                          }}
                        >
                          <LoadingSpinner />
                        </Box>
                      )}

                      <TextField
                        label="Comment"
                        fullWidth
                        multiline
                        rows={4}
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        sx={{ marginTop: 1 }}
                      />
                    </Box>
                  </DialogContent>
                  <Divider />
                  <DialogActions sx={{ p: "12px 24px" }}>
                    <Button
                      onClick={() => {
                        setOpenStatusCommentDialog(false);
                        setComment("");
                        setSelectedStatus("");
                      }}
                      size="small"
                      disabled={loading}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      onClick={handleAddCommentStatus}
                      size="small"
                      disabled={loading}
                    >
                      Save
                    </Button>
                  </DialogActions>
                </Dialog>
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: "24px",
              }}
            >
              <Button
                sx={{ padding: 0, minWidth: 0 }}
                startIcon={<EmailOutlinedIcon />}
                component="a"
                href={`mailto:${data?.["Basic Details"]?.Email || ""}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                EMAIL
              </Button>

              <Button
                sx={{ padding: 0, minWidth: 0 }}
                startIcon={<DescriptionOutlinedIcon />}
                onClick={scrollToResume}
              >
                RESUME
              </Button>
              <Button
                sx={{ padding: 0, minWidth: 0 }}
                startIcon={<LinkIcon />}
                component="a"
                href={
                  data?.["Other Details"]?.Linkedin
                    ? data["Other Details"].Linkedin.startsWith("http")
                      ? data["Other Details"].Linkedin
                      : `https://${data["Other Details"].Linkedin}`
                    : undefined
                }
                target={
                  data?.["Other Details"]?.Linkedin ? "_blank" : undefined
                }
                rel={
                  data?.["Other Details"]?.Linkedin
                    ? "noopener noreferrer"
                    : undefined
                }
              >
                LINKEDIN
              </Button>

              <Button
                sx={{ padding: 0, minWidth: 0 }}
                startIcon={<ScreenShareOutlinedIcon />}
                onClick={handleShareProfile}
              >
                SHARE PROFILE
              </Button>
              <Button
                sx={{ padding: 0, minWidth: 0 }}
                startIcon={<LibraryAddOutlinedIcon />}
                onClick={() => {
                  // const url = `${
                  //   process.env.REACT_APP_FRONTEND_URL ||
                  //   "http://localhost:3000"
                  // }/candidates-description/${candidateId}`;
                  // window.open(url, "_blank");
                  const url = `${process.env.REACT_APP_FRONTEND_URL}/candidates-description/${candidateId}`;
                  window.open(url, "_blank");
                }}
              >
                OPEN IN NEW TAB
              </Button>
            </Box>
          </Box>
        </Box>

        <Tabs
          value={selectedTab}
          onChange={(e, newValue) => setTabValue(newValue)}
          style={{
            margin: "20px 0px",
            borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
          }}
          sx={{
            "& .MuiTabs-indicator": {
              height: "2px",
            },
          }}
        >
          <Tab
            value="CandidateInfo"
            label="Candidate Info"
            sx={{ fontWeight: "500", fontSize: "14px" }}
          />
          {sourceType === "Applicants" && (
            <Tab
              value="Activities"
              label="Activities"
              sx={{ fontWeight: "500", fontSize: "14px" }}
            />
          )}
          <Tab
            value="InternalProfile"
            label="Internal Profile"
            sx={{ fontWeight: "500", fontSize: "14px" }}
          />
        </Tabs>

        {/* Candidate Info Section */}
        {selectedTab === "CandidateInfo" && (
          <Box>
            {renderSection("Basic Details", data["Basic Details"] || {})}
            {renderSection(
              "Professional Details",
              data["Professional Details"] || {}
            )}
            {renderSection("Other Details", data["Other Details"] || {})}
            <Typography
              sx={{ fontWeight: "600", fontSize: "14px" }}
              ref={resumeRef}
            >
              Resume
            </Typography>
            {data?.["More Details"]?.Resume ? (
              <Box sx={{ marginTop: "12px" }}>
                <Box sx={{ marginTop: "12px" }}>
                  <iframe
                    src={
                      data["More Details"].Resume.endsWith(".pdf")
                        ? data["More Details"].Resume
                        : `https://docs.google.com/gview?url=${encodeURIComponent(
                            data["More Details"].Resume
                          )}&embedded=true`
                    }
                    title="Resume Preview"
                    width="100%"
                    height="450px"
                    style={{
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                    }}
                  />
                </Box>
              </Box>
            ) : (
              <Typography sx={{ marginTop: "8px", color: "#999" }}>
                No resume available.
              </Typography>
            )}
          </Box>
        )}

        {selectedTab === "Activities" && (
          <Box sx={{ display: "flex", flexDirection: "column", gap: "24px" }}>
            <Box>
              <Button
                variant="contained"
                onClick={() => setOpenWriteCommentDialog(true)}
              >
                WRITE A COMMENT
              </Button>
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
              {data?.["Recent Activity"]?.map(
                (item, index) =>
                  item?.notes !== null && (
                    <Box
                      key={index}
                      display={{ xs: "block", md: "block", lg: "flex" }}
                      alignItems={"center"}
                      gap={"14px"}
                      sx={{
                        "&:hover .icon-container": {
                          backgroundColor: getColor(item?.notes),
                        },
                        "&:hover .icon": {
                          color: "white !important",
                        },
                        "&:hover .activity-logs": {
                          fontWeight: "500 !important",
                        },
                        display: "flex",
                      }}
                    >
                      {getIcon(item?.notes)}
                      <Box overflow="hidden">
                        <Typography
                          sx={{ fontWeight: 400 }}
                          variant="body2"
                          color="#737791"
                          fontSize={"10px"}
                        >
                          {dayjs(item.date_created).format("DD-MM-YYYY")}
                        </Typography>
                        <Typography
                          className="activity-logs"
                          sx={{
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            fontSize: "14px",
                            color: "#151D48",
                          }}
                        >
                          {item?.entered_by}
                        </Typography>
                        {item?.notes.split("\n").map((line, i) => (
                          <Typography
                            key={i}
                            className="activity-logs"
                            sx={{
                              textOverflow: "ellipsis",
                              overflow: "hidden",
                              fontSize: "14px",
                              color: "#151D48",
                            }}
                          >
                            {line}
                          </Typography>
                        ))}
                      </Box>
                    </Box>
                  )
              )}
            </Box>
          </Box>
        )}

        {selectedTab === "InternalProfile" && (
          <Box>
            <CandidateInternalProfile
              candidateId={candidateId}
              data={candidateData}
              jobId={jobId}
            />
          </Box>
        )}
      </DialogContent>
      <CustomSnackbar
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={() => setSnackbar({ open: false, message: "", severity: "" })}
      />
      <Dialog
        open={openWriteCommentDialog}
        onClose={() => setOpenWriteCommentDialog(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: "12px",
          },
        }}
      >
        <DialogTitle>
          <Typography variant="h6" fontWeight={"bold"}>
            Add a Comment{" "}
          </Typography>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Box sx={{ position: "relative" }}>
            {loading && (
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  zIndex: 10,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(255, 255, 255, 0.6)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "16px",
                }}
              >
                <LoadingSpinner />
              </Box>
            )}

            <TextField
              label="Comment"
              fullWidth
              multiline
              rows={4}
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              sx={{ marginTop: 1 }}
            />
          </Box>
        </DialogContent>
        <Divider />
        <DialogActions sx={{ p: "12px 24px" }}>
          <Button
            onClick={() => {
              setOpenWriteCommentDialog(false);
              setComment("");
            }}
            size="small"
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            size="small"
            disabled={!comment || loading}
            onClick={() => {
              handleAddComment(comment);
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
      <QuestionsPopUp
        open={openQuestionsDialog}
        questionsData={questionsData}
        onClose={() => setOpenQuestionsDialog(false)}
        onSubmit={(quesAnsArray) => handleApplyNow(quesAnsArray)}
        title={title}
      />
    </Dialog>
  );
}
